<template>
    <div class="alibaba-order-total">
        <el-link class="alibaba-order-total-search" type="primary" @click="showTotal">查看统计数据</el-link>

        <el-drawer
            :visible.sync="show"
            direction="rtl"
            :modal="false"
            :modal-append-to-body="false"
            size="800px"
            :withHeader="false"
            class="alibaba-order-drawer"
        >
            <div :style="'height:' + (this.$tools.mainHeight() + 60) + 'px;overflow:auto;'">
                <el-card class="box-card" style="text-align: center">
                    <el-radio-group v-model="page.totalType" @change="showTotal">
                        <el-radio label="D">按日查看</el-radio>
                        <el-radio label="M">按月查看</el-radio>
                    </el-radio-group>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>店铺统计</span>
                    </div>
                    <el-table
                        :data="totle.shop"
                        style="width: 100%"
                        :height="200"
                    >
                        <el-table-column prop="name" label="店铺" width="100"></el-table-column>

                        <el-table-column prop="number" label="销售单" width="50">
                            <template
                                slot-scope="order"
                            >{{ order.row.number - order.row.sampleNumber - order.row.shippingFeeNumber}}</template>
                        </el-table-column>
                        <el-table-column prop="cost" label="销售额" width="100">
                            <template
                                slot-scope="order"
                            >{{ $tools.parsecost(order.row.cost - order.row.shippingFee - order.row.sampleCost, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="number" label="样板单" width="50">
                            <template slot-scope="order">{{order.row.sampleNumber}}</template>
                        </el-table-column>
                        <el-table-column prop="cost" label="样板总额" width="100">
                            <template
                                slot-scope="order"
                            >{{ $tools.parsecost(order.row.sampleCost, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="number" label="运费单" width="50">
                            <template slot-scope="order">{{order.row.shippingFeeNumber}}</template>
                        </el-table-column>
                        <el-table-column prop="cost" label="总运费" width="100">
                            <template
                                slot-scope="order"
                            >{{ $tools.parsecost(order.row.shippingFee, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="number" label="总单量" width="50"></el-table-column>
                        <el-table-column prop="cost" label="总额" width="100">
                            <template slot-scope="order">{{ $tools.parsecost(order.row.cost, true)}}</template>
                        </el-table-column>
                    </el-table>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>销售统计</span>
                    </div>
                    <el-table :data="totle.seller" style="width: 100%" :height="200">
                        <el-table-column prop="name" label="销售员" width="100"></el-table-column>

                        <el-table-column prop="trueNumber" label="销售单" width="50">
                            <template
                                slot-scope="order"
                            >{{ order.row.number - order.row.sampleNumber - order.row.shippingFeeNumber}}</template>
                        </el-table-column>
                        <el-table-column prop="trueCost" label="销售额" width="100">
                            <template
                                slot-scope="order"
                            >{{ $tools.parsecost(order.row.cost - order.row.shippingFee - order.row.sampleCost, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="sampleNumber" label="样板单" width="50">
                            <template slot-scope="order">{{order.row.sampleNumber}}</template>
                        </el-table-column>
                        <el-table-column prop="sampleCost" label="样板总额" width="100">
                            <template
                                slot-scope="order"
                            >{{ $tools.parsecost(order.row.sampleCost, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="shippingFeeNumber" label="运费单" width="50">
                            <template slot-scope="order">{{order.row.shippingFeeNumber}}</template>
                        </el-table-column>
                        <el-table-column prop="shippingFee" label="总运费" width="100">
                            <template
                                slot-scope="order"
                            >{{ $tools.parsecost(order.row.shippingFee, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="number" label="总单量" width="50"></el-table-column>
                        <el-table-column prop="cost" label="总额" width="100">
                            <template slot-scope="order">{{ $tools.parsecost(order.row.cost, true)}}</template>
                        </el-table-column>
                    </el-table>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>客户统计</span>
                    </div>
                    <el-table :data="totle.buyer" style="width: 100%" :height="200">
                        <el-table-column prop="name" label="客户" width="100"></el-table-column>

                        <el-table-column prop="number" label="销售单" width="50">
                            <template
                                slot-scope="order"
                            >{{ order.row.number - order.row.sampleNumber - order.row.shippingFeeNumber}}</template>
                        </el-table-column>
                        <el-table-column prop="cost" label="销售额" width="100">
                            <template
                                slot-scope="order"
                            >{{ $tools.parsecost(order.row.cost - order.row.shippingFee - order.row.sampleCost, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="number" label="样板单" width="50">
                            <template slot-scope="order">{{order.row.sampleNumber}}</template>
                        </el-table-column>
                        <el-table-column prop="cost" label="样板总额" width="100">
                            <template
                                slot-scope="order"
                            >{{ $tools.parsecost(order.row.sampleCost, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="number" label="运费单" width="50">
                            <template slot-scope="order">{{order.row.shippingFeeNumber}}</template>
                        </el-table-column>
                        <el-table-column prop="cost" label="总运费" width="100">
                            <template
                                slot-scope="order"
                            >{{ $tools.parsecost(order.row.shippingFee, true)}}</template>
                        </el-table-column>

                        <el-table-column prop="number" label="总单量" width="50"></el-table-column>
                        <el-table-column prop="cost" label="总额" width="100">
                            <template slot-scope="order">{{ $tools.parsecost(order.row.cost, true)}}</template>
                        </el-table-column>
                    </el-table>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>销量趋势</span>
                    </div>
                    <div id="saleNumber"></div>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>销售额趋势</span>
                    </div>
                    <div id="saleCost"></div>
                </el-card>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    Chart,
    registerInteraction,
    registerAction,
    ActionConstructor,
    getDelegationObject,
} from "@antv/g2";

export default {
    components: {},
    props: {
        isRoot: { type: Boolean, default: false },
        params: { type: Object, default: () => {} },
    },
    data() {
        return {
            char: { saleNumber: null, saleCost: null },
            totle: {},
            page: { totalType: "D" },
            show: false,
            totalAmount: 0,
        };
    },
    mounted() {},
    methods: {
        toFixed(val) {
            return window.parseFloat(val).toFixed(2);
        },
        showTotal() {
            let _this = this;

            _this.totalAmount = 0;
            _this.show = true;

            _this.$http.post(
                [
                    _this.isRoot
                        ? "alibaba/order/total"
                        : "alibaba/order/myTotal",
                    _this.page,
                    _this.params,
                ],
                [
                    function (data) {
                        if (data.saleCost) {
                            for (var i in data.saleCost) {
                                data.saleCost[i].val = _this.$tools.parsecost(
                                    data.saleCost[i].val
                                );

                                _this.totalAmount += data.saleCost[i].val;
                            }
                        }

                        _this.totle = data;
                        _this.render(
                            "saleNumber",
                            data.saleNumber,
                            "date*val",
                            "type"
                        );
                        _this.render(
                            "saleCost",
                            data.saleCost,
                            "date*val",
                            "type"
                        );
                    },
                ],
                ".alibaba-order-drawer"
            );
        },

        render(name, data, position, type, action) {
            let _this = this;

            if (!this.char[name]) {
                this.char[name] = new Chart({
                    container: name,
                    autoFit: true,
                    height: 250,
                });

                this.char[name]
                    .interval()
                    .position(position)
                    .color(type)
                    .adjust([
                        {
                            type: "dodge",
                            marginRatio: 0,
                        },
                    ]);
            }

            this.char[name].data(data);
            this.char[name].render();
        },
    },
};
</script>

<style lang="scss" scoped>
.alibaba-order-total {
    float: right;
    margin-right: 10px;
    margin-top: 10px;
}
</style>